const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/iu;

/** A local readable-view hint; never a click target, authorization or read receipt. */
export async function createChatNotificationViewKey(
  recipientAccountId: string,
  spaceId: string,
  channelId: string,
  subtle: Pick<SubtleCrypto, 'digest'> | undefined = globalThis.crypto?.subtle,
): Promise<string | null> {
  if (
    !subtle ||
    ![recipientAccountId, spaceId, channelId].every(
      (value): boolean => typeof value === 'string' && value.length === 36 && UUID.test(value),
    )
  )
    return null;
  try {
    const scope = JSON.stringify([
      'stitch.notification.chat-view.v1',
      recipientAccountId.toLowerCase(),
      spaceId.toLowerCase(),
      channelId.toLowerCase(),
    ]);
    const digest = await subtle.digest('SHA-256', new TextEncoder().encode(scope));
    if (digest.byteLength !== 32) return null;
    return `chat-v1:${Array.from(new Uint8Array(digest), (byte): string => byte.toString(16).padStart(2, '0')).join('')}`;
  } catch {
    // Missing platform support must not manufacture a matching suppression hint.
    return null;
  }
}
